<template>
  <div v-if="questionData != null" class="exam_right">
    <div class="right_main">

      <!--  单选题-->
      <Single v-if="questionData.questionDto.internalTypeId === 1"/>
      <!--  多选题-->
      <More v-if="questionData.questionDto.internalTypeId === 2"/>
      <!--  判断题-->
      <Judge v-if="questionData.questionDto.internalTypeId === 3"/>

      <!--  填空题-->
      <gapFilling v-else-if="questionData.questionDto.internalTypeId === 4"/>
      <!--  操作题  组合题-->
      <Operation  v-else-if="questionData.questionDto.internalTypeId === 9 || questionData.questionDto.internalTypeId === 6"/>

    </div>
    <div class="right_foot">
      <div class="foot_content">
        <span @click="pre" class="left"><i class="el-icon-arrow-left"></i><p>上一题</p></span>
        <span :class="[{center_active:isMake === true}]" @click="select" class="center"><i
          class="el-icon-search"></i><p>待定</p></span>
        <span @click="next" class="right"><i class="el-icon-arrow-right"></i><p>下一题</p></span>
      </div>
    </div>
  </div>
</template>

<script>
  import * as api from "../../../../../api/testExamApi";
  import {moduleId} from "../../../../../store/modules/exam";
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
  import Single from "./single";
  import Judge from "./judge";
  import Operation from "./operation";
  import More from "./more";
  import gapFilling from "../testComponent/gapFilling"

  export default {
    name: "ExamRight",
    data() {
      return {
        isMake: false,
        examPaperId: 0,

      };
    },
    components: {
      Single,
      Judge,
      Operation,
      More,
      gapFilling
    },
    computed: {

      ...mapState(moduleId, {
        questionData: state => state.questionData,
        nextData: state => state.paperList,
        paperData: state => state.paperData,
      }),

    },
    watch: {
      questionData(val) {
        if (val.makeAnswer) {
          this.isMake = true;
        } else {
          this.isMake = false;
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.nextAnswer()
      })
    }
    ,
    methods: {
      ...mapMutations(moduleId, ['SET_QUESTION_DATA', 'SET_PAPER_LIST', 'SET_LEFT_INDEX', 'MAKE_ANSWER', 'SAVE_PRE_ANSWER']),
      ...mapActions(moduleId, ['preAnswer', 'saveAnswer']),
      pre() {
        if (this.nextData.index === 0) {
          this.$messageError("已是第一题")
        } else {
          this.$emit('pre')
          let index;
          this.nextData.data.forEach((item, i) => {
            if (item.id === this.questionData.id) {
              index = i;
            }
          })

          let data = this.nextData.data[index - 1];
          this.nextData.index = index - 1;

          this.SET_PAPER_LIST(this.nextData);
          this.SET_QUESTION_DATA(data);
          //切换显示答案
          this.answer();
        }


      },
      nextAnswer() {
        var that = this;
        // setTimeout(()=>{
        if (that.questionData && that.questionData.makeAnswer) {
          that.isMake = true;
          //  console.log(that.questionData.makeAnswer)
        } else {
          that.isMake = false;
          //  console.log(that.questionData.makeAnswer)
        }
        //  console.log('js')
        // },2000)
        // console.log('ks')
      },
      next() {
        if (this.nextData.index === this.nextData.data.length - 1) {
          this.$messageError("已是最后一题")
        } else {
          this.$emit('next')
          let index;
          this.nextData.data.forEach((item, i) => {
            if (item.id === this.questionData.id) {
              index = i;
            }
          })

          let data = this.nextData.data[index + 1];
          this.nextData.index = index + 1;
          this.SET_PAPER_LIST(this.nextData);
          this.SET_QUESTION_DATA(data);
          //切换显示答案
          this.answer();
        }
      },


      answer() {
        let obj = {
          "paperId": this.$route.query.paperId,
          "questionId": this.questionData.questionId,
          "userId": sessionStorage.getItem('userId'),
          "classId": this.$route.query.classId,
          "examPaperId": this.paperData.examPaperId
        };
        //上次选择的答案
        this.SAVE_PRE_ANSWER(null)
        this.preAnswer(obj).then((result) => {
          if (result.code == 0){
            this.$emit('getITAnswer', result.data.answer)
          }
        });
      },
      select() {
        // let obj = {
        //   "examPaperId": this.paperData.examPaperId,
        //   "subjectId": this.questionData.questionDto.subjectId,
        //   "classId": this.$route.query.classId,
        //   "courseId": this.$route.query.id,
        //   "paperCode": this.$route.query.paperCode,
        //   "paperId": this.$route.query.paperId,
        //   "questionId": this.questionData.questionId,
        //   "questionType": 1,
        //   "version": this.preAnswer.version + 1,
        //   // "userAnswer":this.radio,
        //   "score": this.questionData.score,
        //   "questionStatus": this.questionData.questionDto.status,
        //   "useTime": "23"
        // };
        // console.log(this.questionData);
        if (this.questionData.makeAnswer) {
          api.cancelRemark(this.paperData.examPaperId, this.questionData.questionId).then((result) => {
            // console.log(result);
            if (result.code === "0") {
              this.$messageSuccess("待定取消成功！");
              this.isMake = false;
              this.MAKE_ANSWER(this.questionData.questionId + "1");
            }
          });
        } else {
          api.remark(this.paperData.examPaperId, this.questionData.questionId, this.questionData.questionDto.internalTypeId).then((result) => {
            // console.log(result);
            if (result.code === "0") {
              this.$messageSuccess("待定保存成功！");
              this.isMake = true;
              this.MAKE_ANSWER(this.questionData.questionId + "0");
            }
          });
        }

      },

    }

  }
</script>

<style lang="scss" scoped>
  .exam_right {
    /*width: calc(100% - 240px);*/
    min-width: 400px;
    flex: 1;
    height: 100%;
    box-sizing: border-box;
    padding: 15px 15px 15px 0px;

    .right_main {
      position: relative;
      height: calc(100% - 77px);
      background: white;
      overflow: auto;

      #title {
        width: 95%;
        margin: auto;
        border-bottom: 1px dashed black;
      }
    }

    .right_foot {
      width: 97%;
      height: 77px;
      margin: auto;
      background: white;

      .foot_content {
        width: 80%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid rgba(238, 238, 238, 1);
        margin: auto;
        text-align: center;

        .left {
          width: 32px;
          height: 32px;
          line-height: 32px;
          display: inline-block;
          border: 1px solid #999999;
          border-radius: 50%;
          margin-top: 15px;
          font-size: 20px;
          cursor: pointer;

          &:hover {
            border-color: #5397F7;
            background: #5397F7;

            i {
              color: white;
            }
          }

          p {
            width: 50px;
            font-size: 12px;
            text-indent: -20px;
          }
        }

        .center {
          width: 32px;
          height: 32px;
          line-height: 32px;
          display: inline-block;
          border: 1px solid #999999;
          border-radius: 50%;
          margin-top: 15px;
          font-size: 18px;
          cursor: pointer;

          &:hover {
            border-color: #5397F7;
            background: #5397F7;

            i {
              color: white;
            }
          }

          p {

            width: 50px;
            font-size: 12px;
            text-indent: -20px;
          }
        }

        .center_active {
          background: #FEBE2F;
          border: 1px solid #FEBE2F;

          i {
            color: white;
          }
        }

        .right {
          width: 32px;
          height: 32px;
          line-height: 32px;
          display: inline-block;
          border: 1px solid #999999;
          border-radius: 50%;
          margin-top: 15px;
          font-size: 20px;
          cursor: pointer;

          &:hover {
            border-color: #5397F7;
            background: #5397F7;

            i {
              color: white;
            }
          }

          p {
            width: 50px;
            font-size: 12px;
            text-indent: -20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testComponent/ExamRight.vue